<template lang='pug'>
v-app#vapp_10_1(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs11, sm10, md9, lg8, text-xs-center)
          v-card(flat)
            breadcrumb(back='page7-2')
              | Estás en: Elige tu Crédito Hipotecario / ¡Quiero contratar mi Crédito Hipotecario!
            v-card-text.text-xs-center.label16tt.withDivider
              | VALIDA TUS REQUERIMIENTOS
            v-layout.pb-0.ma-0(row, justify-center)
              v-flex.pb-0.ma-0(xs12)
                v-layout.pa-0.pl-4.ma-1.my-0.py-0(row, align-center)
                  v-flex.label16tt_blue.pa-0.ma-0.text-xs-left(xs8, sm8)
                    | REQUISITOS DEL SOLICITANTE
                  v-flex.pa-0.ma-0(xs2, sm2)
                    | CUMPLO / NO CUMPLO
                  v-flex.pl-4.ma-0(xs2, sm3)
            v-layout.pb-4.ma-0.pt-0(row, justify-center)
              v-flex.py-0.ma-0(xs12)
                v-layout.pa-0.pl-4.ma-1.leftBlueBorder(row, align-center, v-for='i in 4', :key='i')
                  v-flex.pa-0.ma-0.text-xs-left(xs8, sm8)
                    .parrafoDestacadoB.px-3
                      b {{reactivos[i-1].descripcion}}
                  v-flex.pa-0.ma-0(xs2, sm1)
                    v-btn.toggle.ma-1(:color='testValue(reactivos[i-1].respuesta, true)', @click.prevent='reactivos[i-1].respuesta=true;', block, value='true')
                      | Sí
                  v-flex.pa-0.ma-0(xs2, sm1)
                    v-btn.toggle.ma-2(:color='testValue(reactivos[i-1].respuesta, false)', @click.prevent='reactivos[i-1].respuesta=false;', block, value='false')
                      | No
                  v-flex.pl-4.ma-0(xs2, sm3)
                    v-popover(offset='16', placement='right', trigger='hover' :disabled='reactivos[i-1].respuesta == "none"')
                      v-icon.tooltip-target.info_tooltip(size='20px ', :color='testValue(reactivos[i-1].respuesta == "none", false)')
                        | fas fa-info-circle
                      template(slot='popover')
                        .pa-4(v-if='i==1')
                          | Recuerda que ninguna institución financiera te prestará el 100% del monto que necesitas. El máximo porcentaje que te concederá es un 90%.
                        .pa-4(v-if='i==2 ')
                          div(v-if='reactivos[i-1].respuesta == true')
                            | Te sugerimos planear un fondo de emergencias de por lo menos tres veces tu salario mensual. 
                          div(v-if='reactivos[i-1].respuesta == false')
                            b Crédito Mancomunado: 
                            | Al solicitar esta opción con tu pareja, podrás aumentar el monto de tu préstamo y obtener beneficios como tasas de interés más bajas. 
                        .pa-4(v-if='i==3 ')
                          div(v-if='reactivos[i-1].respuesta == true')
                            b Cofinanciamiento: 
                            | ¡No es necesario perder liquidez! Si cuentas con un programa de apoyo del INFONAVIT o FOVISSTE, puedes sumarlo a tu Crédito Hipotecario. 
                          div(v-if='reactivos[i-1].respuesta == false')
                            | Un pequeño ahorro podría serte útil a la hora de cubrir los gastos notariales, el enganche o el costo del avalúo. ¡Considéralo! 
                        .pa-4(v-if='i==4 ')
                          div(v-if='reactivos[i-1].respuesta == true')
                            | Averigua qué instituciones permiten este conveniente tipo de pago. 
                          div(v-if='reactivos[i-1].respuesta == false')
                            | Si deseas liquidar tu crédito antes del plazo esperado, pagar menos intereses o reducir las mensualidades, deberías considerar esta opción
            v-btn#attachDialog_10_1.btn(depressed, justify-space-between, type='button ', color='secondary ', :disabled='!completo ', @click.prevent="nextPage( 'page7-2'); sendResult(); ")
              | Continuar
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import jsPDF from 'jspdf';
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      msg: 'This is a button',
      reactivos: [{
          descripcion: '1. Monto que necesitas',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'Recuerda que ninguna institución financiera te prestará el 100% del monto que necesitas. El máximo porcentaje que te concederá es un 90%.'
        },
        {
          descripcion: '2. ¿Tomarás este compromiso sólo?',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'Crédito Mancomunado: Al solicitar esta opción con tu pareja, podrás aumentar el monto de tu préstamo y obtener beneficios como tasas de interés más bajas.'
        },
        {
          descripcion: '3. ¿Tienes un ahorro destinado para tu Crédito Hipotecario?',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'Un pequeño ahorro podría serte útil a la hora de cubrir los gastos notariales, el enganche o el costo del avalúo. ¡Considéralo! '
        },
        {
          descripcion: '4. ¿Realizarás pagos anticipados?',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'Si deseas liquidar tu crédito antes del plazo esperado, pagar menos intereses o reducir las mensualidades, deberías considerar esta opción.'
        }
      ],
      progress: false,
      dialog: false,
    }
  },
  computed: {
    completo: function() {
      var complete = true;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == 'none') {
          complete = false;
        }
      })
      if (complete) {
        this.$parent.steps_calc.step3 = true;
      }
      return complete;
    },
    resultado: function() {
      var resultado = 0;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == true) {
          resultado++;
        }
      })
      return resultado;
    }
  },
  methods: {
    downloadPDF() {
      var lineSpace = 7;
      var doc = new jsPDF()
      doc.text('Cumplimiento de requisitos para Crédito Hipotecario', 10, 10)
      doc.setFontSize(12);
      this.reactivos.forEach(function(reactivo, index) {
        if (reactivo.respuesta) {
          doc.setTextColor(0, 255, 0);
          doc.text("[Cumple]", 10, 20 + lineSpace * index);
        } else {
          doc.setTextColor(255, 0, 0);
          doc.text("[No Cumple]", 10, 20 + lineSpace * index);
        }
        doc.setTextColor(0, 0, 0);
        doc.text(reactivo.descripcion, 35, 20 + lineSpace * index);
      })
      doc.save('requisitos.pdf')
    },
    sendResult() {
      this.sent = true;
      this.$parent.results['page8-3'] = this.reactivos;
      this.$parent.results['page8-3-r'] = this.resultado;
    },
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    nextChapter(page) {
      this.progress = true;
      eventBus.$emit('next_chapter', page);
    },
    testValue(value, test) {
      if (value == test) {
        return 'accent';
      }
      return 'greyNormal'
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  }
};
</script>
